export default "__VITE_ASSET__Le3An2o___"